<template>
  <div class="team-avatar-and-name">
    <Avatar
      :src="team?.picture?.pictureUrl"
      type="teamsGroup"
      size="sm"
      bordered
    />
    <BaseSubHeading
      size="large"
      weight="400"
    >
      <slot name="team-name">
        {{ team.name }}
      </slot>
    </BaseSubHeading>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import Avatar from "@/components/Avatar/index.vue"
import { Team } from "@/models"
@Options({
  name: "TeamAvatarAndName",
  components: {
    Avatar,
  },
})
export default class TeamSelectionDropdown extends Vue {
  @Prop({ required: true }) team: Team
}
</script>
